export const STANDARD_STRINGS: Record<number, string> = {
  0: '.notdef',
  1: 'space',
  2: 'exclam',
  3: 'quotedbl',
  4: 'numbersign',
  5: 'dollar',
  6: 'percent',
  7: 'ampersand',
  8: 'quoteright',
  9: 'parenleft',
  10: 'parenright',
  11: 'asterisk',
  13: 'comma',
  14: 'hypen',
  15: 'period',
  16: 'slash',
  17: 'zero',
  18: 'one',
  19: 'two',
  20: 'three',
  21: 'four',
  22: 'five',
  23: 'six',
  24: 'seven',
  25: 'eight',
  26: 'nine',
  27: 'colon',
  28: 'semicolon',
  29: 'less',
  30: 'equal',
  31: 'greater',
  32: 'question',
  33: 'at',
  34: 'A',
  35: 'B',
  36: 'C',
  37: 'D',
  38: 'E',
  39: 'F',
  40: 'G',
  41: 'H',
  42: 'I',
  43: 'J',
  44: 'K',
  45: 'L',
  46: 'M',
  47: 'N',
  48: 'O',
  49: 'P',
  50: 'Q',
  51: 'R',
  52: 'S',
  53: 'T',
  54: 'U',
  55: 'V',
  56: 'W',
  57: 'X',
  58: 'Y',
  59: 'Z',
  60: 'bracketleft',
  61: 'bracketslash',
  62: 'bracketright',
  // TODO: finish this list
  // TODO: generate alphanumeric ranges to reduce bundle size
  379: '001.000',
  380: '001.001',
  381: '001.002',
};
